var exports = {
  "p": "ChannelWelcomeSection.module__channelIcon___T25WS2",
  "kL": "ChannelWelcomeSection.module__container___T25WS2",
  "R_": "ChannelWelcomeSection.module__heading___T25WS2",
  "h_": "ChannelWelcomeSection.module__description___T25WS2",
  "RK": "ChannelWelcomeSection.module__iconSize___T25WS2",
};

module.exports = exports;
